export function popupAjaxOptions(magnificPopup) {
  // const magnificPopup = $.magnificPopup.instance
  const obj = {
    type: 'ajax',
    mainClass: 'MfpMainFade',
    // removalDelay: 160,
    // preloader: false,
    // fixedContentPos: false,
    // prependTo: $('#video-player-placeholder'),
    closeOnContentClick: false,
    closeOnBgClick: false,
    showCloseBtn: false,
    enableEscapeKey: false,
    tLoading:
      '<div class="Aspect-BG-img btn--loading" style="color:var(--brand-curent)"><svg class="icon-svg icon-svg--size-32 btn__spinner" aria-hidden="true" focusable="false"> <use xlink:href="#spinner-button"></use></svg></div>',
    // modal: true,
    // gallery: {
    //   enabled: true,
    //   navigateByImgClick: true,
    //   preload: [0, 1]
    // },
    ajax: {
      settings: null, // Ajax settings object that will extend default one - http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings
      // For example:
      // settings: {cache:false, async:false}

      cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
      tError: '<a href="%url%">The content</a> could not be loaded.', //  Error message, can contain %curr% and %total% tags if gallery is enabled
    },
    callbacks: {
      beforeOpen: () => {
        // $('html').addClass('fancybox-margin fancybox-lock')
        // $('body').addClass('modal-frame-is-opened')
        // console.log('Start of popup initialization')
      },
      afterClose: () => {
        // $('html').removeClass('fancybox-margin fancybox-lock')
        // $('body').removeClass('modal-frame-is-opened')
        // console.log('Popup is completely closed')
      },
      // parseAjax: function (mfpResponse) {
      //   // mfpResponse.data is a "data" object from ajax "success" callback
      //   // for simple HTML file, it will be just String
      //   // You may modify it to change contents of the popup
      //   // For example, to show just #some-element:
      //   // mfpResponse.data = $(mfpResponse.data).find('#some-element')

      //   // mfpResponse.data must be a String or a DOM (jQuery) element

      //   // console.log('Ajax content loaded:', mfpResponse)

      //   if ($(mfpResponse.data).find('#faq-main')) {
      //     faqSection = true
      //   }
      // },
      ajaxContentAdded: () => {
        // Ajax content is loaded and appended to DOM
        // console.log(this.content)

        // $('[js-mfp-close-btn]').click(event => {
        //   $.magnificPopup.close()
        // })
        if (magnificPopup) {
          const closeBtn = '<button title="Close (Esc)" type="button" class="mfp-close"></button>'
          magnificPopup.content.prepend(closeBtn)
        }
      },
    },
  }

  return obj
}
